import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import { CategoryColumn, ContentTypeColumn } from "../ui/Categories/CategoryColumn"
import CategoryFilterSheet from "../ui/Categories/CategoryFilterSheet"
import CategoryItemBrowser from "../ui/CategoryItemBrowser"
import AdPlacement from "../ui/Promotions/AdPlacement"
import useT from "../hooks/useT"
import { useContentTypes } from "../hooks/useCatalogData"
import { usePageTitle } from "../hooks/usePageTitle"
import { stripLang } from "../utils/contentRoutes"
import { contentTypeOnBeforeRender } from "./catalogSSR"

/**
 * /type/:contentTypeId — products of one profile (the product-type tree's;
 * the id is its node's slug, and a former content type id is moved to it by
 * catalogSSR or read as it by the API). A promotion named `type-<id>-carousel`
 * is rendered when it exists.
 */
export default function ContentTypePage() {
  const t = useT()
  const pageContext = usePageContext()
  const contentTypeId = stripLang(pageContext.urlPathname || "/").split("/").filter(Boolean)[1]
  const { list } = useContentTypes()
  const contentType = list.find((ct) => ct.contentId === contentTypeId)
  const name = contentType?.name || pageContext.storefrontContentTypeName || t`Products`
  usePageTitle(name)

  return (
    <div className="w-full flex flex-col items-center mb-24">
      <div className="w-[90%] max-w-w1_xl flex gap-6 mt-6">
        <aside className="hidden md:block w-[250px] shrink-0">
          <CategoryColumn />
          <ContentTypeColumn />
        </aside>
        <div className="flex-1 min-w-0">
          {/* a phone reads the name on the filter button: the heading is the desktop's */}
          <h1 className="hidden md:block m-0 mb-4 text-[44px] lg:text-[54px] font-bold text-left text-text leading-tight">{name}</h1>
          {contentTypeId && <AdPlacement placement={`type-${contentTypeId}-carousel`} className="mt-6 mb-8" />}
          {/* a phone has no side column: the same lists open as a sheet */}
          <div className="mb-6 md:hidden">
            <CategoryFilterSheet label={t`Product Types`} value={name} />
          </div>
          <CategoryItemBrowser key={contentTypeId} placement="content_type" contentTypes={contentTypeId ? [contentTypeId] : []} />
        </div>
      </div>
    </div>
  )
}

ContentTypePage.onBeforeRender = contentTypeOnBeforeRender
